import http from './http';

export const getAllAuthors = () => http.get('api/authors');

export const getAuthorByName = (name) => http.get(`api/author/name/${name}`);

export const postAuthor = (data) => http.post('api/autores/register/QGE1ZWRpdG9yYQ==', data);



// WEBPACK FOOTER //
// ./src/services/Author.js